/**
 * The filter vocabulary (operators, field definitions, `FilterCriteria`) now
 * lives in `@ais-ui/filter-query` so it can be shared with AISAdmin. This file
 * re-exports it for MDM's existing imports and keeps the MDM-only helpers.
 */
import { HumanOperator } from '@ais-ui/filter-query';

export {
  Operator,
  HumanOperator,
  humanOperatorToOperator,
  operatorAndValueToHumanOperator,
  stringAndContainsOperators,
  numberOperators,
  MappedShipDbToHumanOperators,
  MappedShipDbTypeToFrontendType,
  filterOptionsTemplate,
} from '@ais-ui/filter-query';
export type { FilterCriteria } from '@ais-ui/filter-query';

export const applyFilter = (
  rowValue: any,
  filterValue: any,
  operator: HumanOperator,
) => {
  if (typeof rowValue === 'string' && typeof filterValue === 'string') {
    rowValue = rowValue.toLowerCase();
    filterValue = filterValue.toLowerCase();
  }

  switch (operator) {
    case HumanOperator.Equal:
      return rowValue === filterValue;
    case HumanOperator.NotEqual:
      return rowValue !== filterValue;
    case HumanOperator.GreaterThan:
      return rowValue > filterValue;
    case HumanOperator.LessThan:
      return rowValue < filterValue;
    case HumanOperator.GreaterThanOrEqual:
      return rowValue >= filterValue;
    case HumanOperator.LessThanOrEqual:
      return rowValue <= filterValue;
    case HumanOperator.Contains:
      return rowValue.includes(filterValue);
    case HumanOperator.NotContains:
      return !rowValue.includes(filterValue);
    case HumanOperator.StartsWith:
      return rowValue.startsWith(filterValue);
    case HumanOperator.DoesNotStartWith:
      return !rowValue.startsWith(filterValue);
    case HumanOperator.EndsWith:
      return rowValue.endsWith(filterValue);
    case HumanOperator.DoesNotEndWith:
      return !rowValue.endsWith(filterValue);
    default:
      return true; // Default to true if no valid operator is provided
  }
};
